<h2 mat-dialog-title>Nowy kod zaproszenia</h2>
<mat-dialog-content>
  <mat-form-field [style.width.px]="500">
    <input matInput [(ngModel)]="inviteCode" />
    <span matSuffix style="text-decoration: underline; cursor: pointer;" (click)="copyToClipboard()">Kopiuj</span>
  </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions>
  <button matButton (click)="closeDialog()">Anuluj</button>
  <button matButton cdkFocusInitial (click)="saveInviteCode()">Dodaj</button>
</mat-dialog-actions>